import { useTranslation } from 'react-i18next';
import { DropdownMenuItem } from './ui/dropdown-menu';
import { Check, Globe } from 'lucide-react';

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'ru', label: 'Русский' },
    { code: 'en', label: 'English' }
  ];

  return (
    <>
      {languages.map((lang) => (
        <DropdownMenuItem
          key={lang.code}
          onClick={() => i18n.changeLanguage(lang.code)}
          className="flex items-center justify-between"
        >
          <div className="flex items-center">
            <Globe className="mr-2 h-4 w-4" />
            <span>{lang.label}</span>
          </div>
          {i18n.language === lang.code && (
            <Check className="h-4 w-4" />
          )}
        </DropdownMenuItem>
      ))}
    </>
  );
};
